import { Snackbar, Alert, Card, Fade } from '@mui/material';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import AccountComponent from './AccountComponent';
import { useNavigate } from 'react-router-dom';
import Api from '../Services/Api';
import Loading from '../components/Loading';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import LanguageSelector from './LanguageSelector';

const Account = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [gmailSuccess, setGmailSuccess] = useState(false);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [gmailDisconnectSuccess, setGmailDisconnectSuccess] = useState(false);
    const navigate = useNavigate();
    const randomAction = useRef('');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const gmailParam = urlParams.get('gmailSuccess');
        setGmailSuccess(!!gmailParam);
        Api.getUserData().then((response) => {
            setUser(response);
            if (response?.actions && Object.keys(response.actions).length > 0) {
                const keys = Object.keys(response.actions);
                const action = response.actions[keys[Math.floor(Math.random() * keys.length)]];
                randomAction.current = `${t('minutesSaved')} ${action.minutes} ${t('minutes')} ${t('savedIn')} ${t(action.label.toLowerCase())}`;
            }
            setLoading(false);
        }).catch(() => {
            navigate('/');
        });
    }, []);

    const disconnectGmail = useCallback(async () => {
        await Api.disconnectGmail();
        setUser((prev) => ({ ...prev, gmail: false }));
        setGmailDisconnectSuccess(true);
    }, []);

    const accent = theme.palette.secondary?.main || '#76A9AC';
    const cardBg = 'rgba(22, 34, 44, 0.92)';

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100dvh',
                padding: 16,
                boxSizing: 'border-box',
            }}
        >
            <Loading loading={loading} />

            <Fade in={!loading} timeout={400}>
                <Card
                    elevation={4}
                    sx={{
                        padding: { xs: '24px 16px', sm: '32px 28px' },
                        margin: 'auto',
                        backgroundColor: cardBg,
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '16px',
                        backdropFilter: 'blur(24px)',
                        WebkitBackdropFilter: 'blur(24px)',
                        maxWidth: 420,
                        width: '100%',
                    }}
                >
                    {!loading && (
                        <>
                            <AccountComponent
                                user={user}
                                disconnectGmail={disconnectGmail}
                                randomAction={randomAction.current}
                            />
                            <LanguageSelector />
                        </>
                    )}
                </Card>
            </Fade>

            <Snackbar
                open={gmailSuccess}
                autoHideDuration={4000}
                onClose={() => setGmailSuccess(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setGmailSuccess(false)}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%', borderRadius: '12px' }}
                >
                    {t('gmailConnected')}
                </Alert>
            </Snackbar>

            <Snackbar
                open={gmailDisconnectSuccess}
                autoHideDuration={4000}
                onClose={() => setGmailDisconnectSuccess(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setGmailDisconnectSuccess(false)}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%', borderRadius: '12px' }}
                >
                    {t('gmailDisconnected')}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Account;
